import React, {useState, useEffect} from 'react'
import { useHistory } from 'react-router-dom'
import Section from '../components/dashboard/section'
import {Spinner} from 'react-bootstrap'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import MUIDataTable from 'mui-datatables';
import axios from 'axios'
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Bar, Line } from 'react-chartjs-2'
import { faSignOutAlt, faUserPlus, faHome, faUserLock, faCalendarPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button , Container, Row, Col} from 'react-bootstrap';
const bodyScrollLock = require('body-scroll-lock');




const { parseCookies } = require('nookies');





const Clients = () => {
  //Setto gli state
  const [allUsers, viewUsers] = useState([{}])
  const [loading, setLoading] = useState(false)
  const [allCostumers, viewCostumers] = useState('')
  const [allUsersC, viewUsersC] = useState('')
  const [allApp, viewApp] = useState('')
  const cookies = parseCookies()
  const history = useHistory()

  //Recupero i dati dal db
  useEffect(() => {
    let mounted = true
    const fetch = async () => {
      const users = await axios.get(`${window.$apiEndpoint}/products/fetch`, {
        headers: {
          "x-access-token": cookies.token
        }
      });
      try {
        if(mounted){
          viewUsers(users.data)
        }
      } catch (e) {
        console.log(e)
      }
      setLoading(true)
    }
    fetch();
    return () => {
      mounted = false
    }
  }, [cookies.token])

  console.log(allUsers)





  //Configuro le colonne della tabella
  const columns = ["Nome Prodotto", "Categoria Padre", "Sotto-Categoria", "Costo", "Id"];
  const options = {
    filter: false,
    selectableRows: false,
    filterType: "dropdown",
    rowsPerPage: 5,
    onRowClick:( rowData, rowState)  => {
      console.log(rowData[4])
      history.push('/user-profile/'+rowData[4])
    },
    textLabels: {
      body: {
        noMatch: "Spiacenti, nessun record corrispondente trovato",
        toolTip: "Ordinare",
        columnHeaderTooltip: column => `Ordinare per ${column.label}`
      },
      pagination: {
          next: "Pagina successiva",
          previous: "Pagina Precedente",
          rowsPerPage: "Righe per pagina:",
          displayRows: "of",
        },
        toolbar: {
          search: "Cerca",
          downloadCsv: "Scarica CSV",
          print: "Stampa",
          viewColumns: "Vedi Collonne",
          filterTable: "Tabella dei filtri",
        },
        filter: {
          all: "Tutto",
          title: "FILTRI",
          reset: "RIPRISTINA",
        },
        viewColumns: {
          title: "Mostra colonne",
          titleAria: "Mostra / Nascondi colonne tabella",
        },
  }
  };

  const theme = createMuiTheme({
    overrides: {
      MUIDataTableHeadCell:{
        root: {
          fontFamily: "'Raleway', sans-serif",
          fontWeight: '200',

        },
      },
      MuiIconButton: {
        root: {
          color: 'grey',

        },
      },
      MuiTableCell:{
        body: {
            backgroundColor: '#00968817',

          },
      },
      MUIDataTableHeadCell: {
        fixedHeader: {
          fontFamily: "'Raleway', sans-serif",
          fontWeight: '200',
          backgroundColor: ' white',
        },

      },

      MuiButton: {
        root: {
          fontFamily: "'Raleway', sans-serif",
          fontWeight: '200',
          backgroundColor: ' white',
        },

      },
      MuiTypography: {
        body2: {
          fontFamily: "'Raleway', sans-serif",
          fontWeight: '200',
          backgroundColor: ' white',
        },

      },
      MuiMenuItem: {
        root: {
          fontFamily: "'Raleway', sans-serif",
          fontWeight: '200',
          backgroundColor: ' white',
        },

      },
      MuiTableCell: {
        root: {
          fontFamily: "'Raleway', sans-serif",
          fontWeight: '400',
      },
    },
    MUIDataTableToolbar: {
      hover: {
        color: '#616161',
    },
  },
    },
  });

  const ErrorChart = ({ data }) => {
    return (
      <div>
        <Bar data={data}>
        </Bar>
      </div>
    );

  }




  return (
    <>

    <Container fluid>
      <Row>
      <Col xs={12}>
      <div className="card border-left-warning mt-6 shadow h-100 py-2 px-4">

      <span style={{ fontSize: "2vh", fontWeight: "400", marginTop: '2vh',}}>Lista Prodotti</span>
      <span style={{ fontSize: "1.2vh", fontWeight: "200"}}> Cliccando sulla righa si entra nel dettaglio del prodotto</span>

              <div className="overflow-x-scroll lg:overflow-hidden">
                {loading ?
                <MuiThemeProvider theme={theme}>
                <MUIDataTable
                title={""}
                data={allUsers}
                columns={columns}
                options={options}
                /></MuiThemeProvider>: <center><Spinner animation="border" /></center>}
              </div>
              </div>

              </Col>

          </Row>

    </Container>
    </>
  )
}
export default Clients
